import { persistentMap } from '@nanostores/persistent';

export type AI_Model = 'mini' | 'standard' | 'pro' | 'ultra' | 'mock';

const legacyAIModelMap: Record<string, AI_Model> = {
  'dev-ai-model': 'mini',
  'dev-better': 'standard',
  custom: 'pro',
  'prod-ai-model': 'ultra',
  'dev-mock-ai-model': 'mock',
};

export function normalizeAIModel(value: string): AI_Model {
  if (value === 'mini' || value === 'standard' || value === 'pro' || value === 'ultra' || value === 'mock') {
    return value;
  }

  return legacyAIModelMap[value] ?? 'mock';
}

export type LLM_Provider = 'aws' | 'gcp';

import type { Framework, Language } from '~/lib/stores/techStackSelection';

type projectSource = 'github' | 'community_template' | 'alpha_template';

export type SelectionValues = {
  projectName: string;
  temporaryProjectRules: string;
  netlifyAccessToken: string;
  netlifySiteId: string;
  netlifySiteUrl: string;
  githubAccessToken: string;
  aiModel: AI_Model;
  llmProvider: LLM_Provider;
  framework: Framework;
  language: Language;
  presetModalView: 'presets' | 'custom';
  rememberCustomStack: 'true' | 'false';
  hasInteractedWithModal: 'true' | 'false';
  projectSource?: projectSource;
  templateId?: string;
  templateName?: string;
};

export const selectionStore = persistentMap<SelectionValues>('selection', {
  projectName: 'Untitled',
  aiModel: 'mock',
  llmProvider: 'aws',
  temporaryProjectRules: '',
  githubAccessToken: '',
  netlifyAccessToken: '',
  netlifySiteId: '',
  netlifySiteUrl: '',
  framework: 'react_tailwind',
  language: 'ts',
  presetModalView: 'presets',
  rememberCustomStack: 'true',
  hasInteractedWithModal: 'false',
  projectSource: undefined,
  templateId: undefined,
  templateName: undefined,
});

if (typeof window !== 'undefined') {
  selectionStore.subscribe((selection) => {
    const normalizedAIModel = normalizeAIModel(selection.aiModel as string);

    if (normalizedAIModel !== selection.aiModel) {
      selectionStore.setKey('aiModel', normalizedAIModel);
    }
  });
}
